import { StoreView } from './storeViews'

const matchLocation = (
  matcher: RegExp | ((location: Location) => boolean),
  location: Location,
) => {
  if (matcher instanceof RegExp) {
    return matcher.test(location.href)
  } else {
    return matcher(location)
  }
}

export function getActiveStoreView(
  storeViews: StoreView[],
  location: Location,
) {
  const activeStoreView = storeViews.find(
    (sf) => sf.location !== undefined && matchLocation(sf.location, location),
  )

  if (!activeStoreView) {
    const defaultStoreView = storeViews.find((sf) => sf.default)
    if (process.env.NODE_ENV === 'development' && !defaultStoreView) {
      throw new Error(
        'Shop has no default StoreView. A default StoreView is required.',
      )
    }
    // only happens in development
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return defaultStoreView!
  }

  return activeStoreView
}
